module.exports = __webpack_public_path__ + "img/Roadshow SMK Candra Naya.80364f1b.jpg";